import {
  RecipientOrderMatch,
  REFUND_DESTINATION_PROVIDERS,
} from "@redotech/redo-return-core-common/third-party-refunds/recipient";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const refundDestinationRecipientInput = z.object({
  email: z.string().nullish(),
  phone: z.string().nullish(),
});

const refundDestinationRecipientOutput = z.object({
  email: z.string().nullish(),
  phone: z.string().nullish(),
  matchedOrderContact: createEnum(RecipientOrderMatch).nullish(),
});

/** Null provider clears the destination, reverting to the original payment method. */
export const setRefundDestination = {
  name: "setRefundDestination" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    provider: createEnum(REFUND_DESTINATION_PROVIDERS).nullish(),
    recipient: refundDestinationRecipientInput.nullish(),
  }),
  output: z.object({
    provider: createEnum(REFUND_DESTINATION_PROVIDERS).nullish(),
    recipient: refundDestinationRecipientOutput.nullish(),
  }),
};
